module.exports = __webpack_public_path__ + "static/media/icon_drogas.bd9b2c7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_drogas.svg
// module id = 521
// module chunks = 0